const degree = [{
  path: 'degree/index',
  component: resolve => require(['../../../../components/pages/registerstudentpay/degree'], resolve)
}]
export default degree



// WEBPACK FOOTER //
// ./src/router/pages/registerstudentpay/degree/index.js